export const formatHeadingSize = ({ headingSizeMobile, headingSizeTablet, headingSizeDesktop }) => ({
  headingSizeMobile: headingSizeMobile?.toLowerCase(),
  headingSizeTablet: headingSizeTablet?.toLowerCase(),
  headingSizeDesktop: headingSizeDesktop?.toLowerCase(),
});

export const formatEyebrowSize = ({ eyebrowSizeMobile, eyebrowSizeTablet, eyebrowSizeDesktop }) => ({
  eyebrowSizeMobile: eyebrowSizeMobile?.toLowerCase(),
  eyebrowSizeTablet: eyebrowSizeTablet?.toLowerCase(),
  eyebrowSizeDesktop: eyebrowSizeDesktop?.toLowerCase(),
});
